import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import featureStateSelector from './featureStateSelector'
import { ProductTagsState } from '../types'

export const currentPageSelector = createSelector<ReduxState, ProductTagsState, number>(
  featureStateSelector,
  state => state.pagination.currentPage
)
